$(() => {
  const password_input        = document.getElementById('input-new-password');
  const password_verify_input = document.getElementById('input-verify-password');

  function validatePassword() {
    if (password_input.value !== password_verify_input.value) {
      password_verify_input.setCustomValidity("Passwords don't match.");
    } else {
      password_verify_input.setCustomValidity('');
    }
  }

  if (password_input && password_verify_input) {
    password_input.onchange       = validatePassword;
    password_verify_input.onkeyup = validatePassword;
  }
});
